/**
 * Add Component Button
 * 
 * Dropdown button to add new components
 * 
 * @package TopBuddy
 */

import { useState, useRef, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import ProBadge from '../ProBadge';

const AddComponentButton = ({ availableComponents, onAddComponent, isProActive }) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen]);

	const handleAddComponent = (componentId, isPro) => {
		if (isPro && !isProActive) {
			return;
		}
		onAddComponent(componentId);
		setIsOpen(false);
	};

	return (
		<div className="topbuddy-add-component" ref={dropdownRef}>
			{isOpen && (
				<div className="topbuddy-add-component__dropdown">
					<div className="topbuddy-add-component__dropdown-header">
						{__('Add Element', 'topbuddy')}
					</div>
					<ul className="topbuddy-add-component__list">
						{availableComponents.map((component) => {
							const isPro = component.pro || false;
							const isDisabled = isPro && !isProActive;

							return (
								<li
									key={component.id}
									className={`topbuddy-add-component__item ${isDisabled ? 'is-disabled' : ''}`}
								>
									<button
										type="button"
										className="topbuddy-add-component__item-button"
										onClick={() => handleAddComponent(component.id, isPro)}
										disabled={isDisabled}
									>
										<div className="topbuddy-add-component__item-icon">
											{component.icon_type && (
												<span className={`dashicons ${component.icon_type}`}></span>
											)}
										</div>
										<div className="topbuddy-add-component__item-info">
											<div className="topbuddy-add-component__item-name">
												{component.name}
											{isPro && <ProBadge />}
											</div>
											{component.description && (
												<div className="topbuddy-add-component__item-description">
													{component.description}
												</div>
											)}
										</div>
									</button>
								</li>
							);
						})}
					</ul>
				</div>
			)}

			<button
				type="button"
				className="topbuddy-add-component-button"
				onClick={() => setIsOpen(!isOpen)}
				disabled={availableComponents.length === 0}
			>
				<span className="dashicons dashicons-plus-alt2"></span>
				{__('Add Element', 'topbuddy')}
			</button>
		</div>
	);
};

export default AddComponentButton;
